module.exports = __webpack_public_path__ + "img/cd-madrigal-for-christmas.618af0e9.jpg";